/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type TagCategory from 'linced-admin/models/posts/tag-category';

// Proto: posts.TagTemplate.
export default class Tag extends Model {
  declare [Type]: 'posts/tag';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @belongsTo('posts/tag-category', { async: true, inverse: 'tags' })
  declare categoryId: AsyncBelongsTo<TagCategory>;

  @alias('categoryId')
  declare category: AsyncBelongsTo<TagCategory>;
}
